UTIL.registerTask('orders', 'confirm', function() {
    (function($) {
        var loopTimer;
        var loopCount = 0;
        
        if (ab.orderNumber) {
            loopTimer=setInterval(function(){confirmOrderCompleted()},1000);
        }

        function confirmOrderCompleted() {
            clearInterval(loopTimer);

            if (loopCount >= 20) window.location.replace(ab.redirect);

            $.ajax(DEFINES.apiUrl + "/orders/" + ab.orderNumber + "/completed", {
                method: "GET",
                headers: UTIL.authHeader
            }).success(function() {
                window.location.replace(ab.redirect);
            }).fail(function(error) {
                loopTimer = setInterval(function () {
                    confirmOrderCompleted();
                }, 1000);
            });

            loopCount += 1;
        }
    }(jQuery));
});